;(function(w){
	function Nuc(data){
		$('select.selectric').selectric({ maxHeight : 250, arrowButtonMarkup:'<b class="arrow"></b>' });

		var formulario = new Formulario(data.id, data.url, data.formulario);// Le paso el id del landing y la data para armar el form

		
		/* if($('.banner-online').length > 0 && $('.banner-online').data('accion') == 'recinto'){
			$('.banner-online a').bind('click', onClickBannerOnline);
		} */

		var tabs = document.getElementById('tabs');
		
		var tab_actual = $(tabs).find('li.active').index();
		
		if(tab_actual == -1){
			tab_actual = 0;
			goTab(0);
		}

		
		if($(tabs).find('li').length > 1){
			$(tabs).find('li > a').bind('click', onClickTab);
		}else{
			$(tabs).find('li > a').eq(0).bind('click', function(e){e.preventDefault()});	
		}

		$('.acordion').each(function(){
			if($(this).find('> li').length == 1){
				$(this).find('> li input[type="checkbox"]').attr('checked',false);
			}
		})

		$('.bt-masinfo').bind('click', onClickBtnMasInfo);
				

		function onClickTab(e){
			e.preventDefault();
			
			goTab($(this).parent().index());
		}

		function goTab(tab_index){
			$(tabs).find('li').eq(tab_actual).removeClass('active');
			$('.tab_content').eq(tab_actual).removeClass('active');

			tab_actual = tab_index;
			
			$(tabs).find('li').eq(tab_actual).addClass('active');
			$('.tab_content').eq(tab_actual).addClass('active');
		}

		function onClickBtnMasInfo(e){
			formulario.setPrograma($(this).data('id'));
			$('html,body').animate({scrollTop: $('.form').offset().top},700);
		}

		/* function onClickBannerOnline(e){
			e.preventDefault();
			formulario.setRecinto($('.banner-online').data('recinto-id'));
			formulario.highlight('recinto_id');
			$('html,body').animate({scrollTop: $('.form').offset().top},700);
		} */		
	}
	
	w.Nuc = Nuc;
})(window)
